import RatingHandler from "./mongoEndpoints/ratingHandler";
import ProductHandler from "./mongoEndpoints/productHandler";
import BuyerHandler from "./mongoEndpoints/buyerHandler";
import AuthHandler from "./mongoEndpoints/authHandler"


class MongoHandler {
  constructor() {
    this.baseURL = process.env.REACT_APP_API_URL + "mongo";
    this.basicUsername = process.env.REACT_APP_BASIC_USERNAME;
    this.basicPassword = process.env.REACT_APP_BASIC_PASSWORD;

    // Initialize handlers
    this.ratingHandler = new RatingHandler(
      this.baseURL,
      this.basicUsername,
      this.basicPassword
    );
    this.productHandler = new ProductHandler(
      this.baseURL,
      this.basicUsername,
      this.basicPassword
    );
    this.buyerHandler = new BuyerHandler(
      this.baseURL,
      this.basicUsername,
      this.basicPassword
    );
    this.authHandler = new AuthHandler(
      this.baseURL,
      this.basicUsername,
      this.basicPassword
    );
  }
  // Expose ProductHandler methods through MongoHandler
  async getAllProducts() {
    return await this.productHandler.getAllProducts();
  }

  async getFilteredProducts(filter) {
    return await this.productHandler.getFilteredProducts(filter);
  }

  async getProductByProductId(productId) {
    return await this.productHandler.getProductByProductId(productId);
  }

  async getProductImagesByImageId(imageId) {
    return await this.productHandler.getProductImagesByImageId(imageId);
  }
  
  async updateProduct(productId, body) {
    return await this.productHandler.updateProduct(productId, body);
  }

  async getShippingCosts() {
    const credentials = `${this.basicUsername}:${this.basicPassword}`;
    const base64Credentials = btoa(credentials);

    const header = {
      "Content-Type": "application/json",
      "Authorization": `Basic ${base64Credentials}`,
      Accepts: "application/json"
    };

    try {
      const response = await fetch(this.baseURL + "/shipping_costs/", {
        method: "GET",
        headers: header,
      });
      const json = await response.json();
      if (response.ok) {
        return json;
      }
    } catch (error) {
      console.log("Backend not reachable", error);
    }
  }

  // Expose BuyerHandler methods through MongoHandler
  async getBuyerById(id) {
    return await this.buyerHandler.getBuyerById(id);
  }

  async createBuyer(body) {
    return await this.buyerHandler.createBuyer(body);
  }

  async deleteBuyer(id) {
    return await this.buyerHandler.deleteBuyer(id);
  }

  // Expose RatingHandler methods through MongoHandler
  async getAllRatings() {
    return await this.ratingHandler.getAllRatings();
  }

  async getAllRatingsByProduktId(id) {
    return await this.ratingHandler.getAllRatingsByProduktId(id);
  }

  async getAllEnabledRatingsByProduktId(id) {
    return await this.ratingHandler.getAllEnabledRatingsByProduktId(id);
  }

  async createNewRating(ratingData) {
    return await this.ratingHandler.createNewRating(ratingData);
  }

  async updateRating(id, updatedData) {
    return await this.ratingHandler.updateRating(id, updatedData);
  }

  async deleteRating(id) {
    return await this.ratingHandler.deleteRating(id);
  }
  
  async login(loginData) {
    return await this.authHandler.login(loginData);
  }
  
  async logout(token) {
    return await this.authHandler.logout(token);
  }
  
  async checkTokenAndRefresh(token) {
    return await this.authHandler.checkTokenAndRefresh(token);
  }
}

export default MongoHandler;